import { CreateReport13Form } from './create-report-#-13-form'

export const CreateReport13 = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateReport13Form onCloseModal={onCloseModal} />
}
